import Api from "@/services/api";

export default {
  archiveAll() {
    return Api().put("/archive").then(res => res.data);
  }
}